module.exports = __webpack_public_path__ + "img/logo-installment-KFC.51a082c7.png";